import { useEffect } from 'react';
import { useAuth } from '@flote/app-core';

/**
 * Syncs auth state to Sentry user context for error tracking.
 * Must be placed inside AuthProvider.
 */
export function SentryAuthSync() {
  const { customer, isAuthenticated } = useAuth();

  useEffect(() => {
    import('@flote/sentry-browser/api').then(({ setUser, setContext }) => {
      if (isAuthenticated && customer) {
        setUser({
          id: String(customer.id),
          email: customer.email ?? undefined,
          username: customer.companyName ?? undefined,
        });
        setContext('customer', {
          id: customer.id,
          email: customer.email,
          companyName: customer.companyName,
          companyNumber: customer.companyNumber,
          phone: customer.phone,
        });
      } else {
        setUser(null);
      }
    });
  }, [customer, isAuthenticated]);

  return null;
}
